<div class="menu-mobile-container">
  <div class="menu-mobile-topo">
    <img class="menu-mobile-avatar" [src]="urlFotoUsuario ?? './assets/sem-img.svg'" [alt]="'Foto de ' + (usuario.nome ?? 'usuário')" />

    <div class="menu-mobile-usuario-info">
      <span class="menu-mobile-usuario-nome ellipse">{{ usuario.nome ?? '--' }}</span>
      <span class="menu-mobile-usuario-cargo ellipse">{{ usuario.perfil?.nome ?? '--' }}</span>
    </div>

    <button type="button" class="menu-mobile-btn-fechar" (click)="fechar()" aria-label="Fechar menu">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="menu-mobile-divisor"></div>

  <nav class="menu-mobile-lista">
    <div class="menu-mobile-item" [class.menu-mobile-item-selecionado]="moduloSelecionado === null"
        role="button" tabindex="0" (click)="irParaHome()" (keydown.enter)="irParaHome()">
      <img class="menu-mobile-item-icone" [src]="iconeModulo('home', moduloSelecionado === null)" alt="" />
      <span class="menu-mobile-item-texto ellipse" [class.menu-mobile-item-texto-selecionado]="moduloSelecionado === null">Home</span>
    </div>

    @for (modulo of modulos; track modulo.idModulo) {
      <div class="menu-mobile-item" [class.menu-mobile-item-selecionado]="moduloSelecionado?.idModulo === modulo.idModulo"
          role="button" tabindex="0" (click)="clicarModulo(modulo)" (keydown.enter)="clicarModulo(modulo)">
        <img class="menu-mobile-item-icone"
            [src]="iconeModulo(modulo.iconeModulo, moduloSelecionado?.idModulo === modulo.idModulo)"
            alt="" />
        <span class="menu-mobile-item-texto ellipse" [class.menu-mobile-item-texto-selecionado]="moduloSelecionado?.idModulo === modulo.idModulo">
          {{ modulo.nomeModulo }}
        </span>
        @if (modulo.rotinas?.length > 1) {
          <mat-icon class="menu-mobile-item-seta" [class.menu-mobile-item-seta-aberta]="moduloExpandidoId === modulo.idModulo">expand_more</mat-icon>
        }
      </div>

      @if (moduloExpandidoId === modulo.idModulo) {
        @for (rotina of modulo.rotinas; track rotina.id) {
          <div class="menu-mobile-subitem" [class.menu-mobile-subitem-selecionado]="rotinaSelecionada?.id === rotina.id"
              role="button" tabindex="0" (click)="clicarRotina(modulo, rotina)" (keydown.enter)="clicarRotina(modulo, rotina)">
            <span class="menu-mobile-subitem-texto ellipse" [class.menu-mobile-subitem-texto-selecionado]="rotinaSelecionada?.id === rotina.id">
              {{ rotina.nome }}
            </span>
          </div>
        }
      }
    }
  </nav>

  <div class="menu-mobile-rodape">
    <button type="button" class="menu-mobile-btn-sair" (click)="sair()">
      <mat-icon>logout</mat-icon>
      <span>Sair</span>
    </button>
  </div>
</div>
